import { KeySet } from "@/services/keyCodeService/keyCode.types";

export const keyMap: Record<KeySet, number[]> = {
  KEY_RIGHT: [39],
  KEY_LEFT: [37],
  KEY_DOWN: [40],
  KEY_UP: [38, 229],

  KEY_ENTER: [13],
  KEY_BACK: [8, 10009, 65385, 461],
  KEY_SPACE: [32],
  KEY_ESC: [27],

  KEY_CHANNEL_PLUS: [107, 427, 33],
  KEY_CHANNEL_MINUS: [109, 428, 34],

  KEY_PLAY_PAUSE: [10252],
  KEY_PAUSE: [19],
  KEY_PLAY: [415],
  KEY_STOP: [413],
  KEY_FASTER: [417],
  KEY_SLOWER: [412],
  KEY_REC: [416],

  KEY_NUMERIC_0: [96, 48],
  KEY_NUMERIC_1: [97, 49],
  KEY_NUMERIC_2: [98, 50],
  KEY_NUMERIC_3: [99, 51],
  KEY_NUMERIC_4: [100, 52],
  KEY_NUMERIC_5: [101, 53],
  KEY_NUMERIC_6: [102, 54],
  KEY_NUMERIC_7: [103, 55],
  KEY_NUMERIC_8: [104, 56],
  KEY_NUMERIC_9: [105, 57]
};

export function keyCodeFinder(keyCode: number): KeySet | undefined {
  for (const [key, value] of Object.entries(keyMap)) {
    if (value.includes(keyCode)) {
      return key as KeySet;
    }
  }
  return undefined;
}
